import { API_BASE_URL } from "../config/api";
import React, { useEffect, useState } from "react";
import axios from "axios";

function CurrentComplaints() {
  const [complaints, setComplaints] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const res = await axios.get(API_BASE_URL + "/api/complaints");
    
    // only pending complaints
    const pending = res.data.filter(c => c.status === "Open");
    setComplaints(pending);
  };

  return (
    <div className="space-y-4">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">Service Desk</p>
        <h1 className="mt-1 text-2xl font-bold text-slate-950">Current Complaints</h1>
      </div>

      {complaints.length === 0 ? (
        <div className="rounded-2xl border border-slate-200 bg-white p-6 text-center text-sm text-slate-500 shadow-sm">
          No current complaints found.
        </div>
      ) : (
        <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          {complaints.map((c) => (
            <article key={c._id} className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Company</p>
                  <h2 className="mt-1 break-words text-base font-bold text-slate-950">{c.company || "-"}</h2>
                </div>
                <span className="shrink-0 rounded-full bg-amber-100 px-3 py-1 text-[10px] font-bold uppercase text-amber-700">
                  {c.status || "Open"}
                </span>
              </div>
              <div className="mt-4 rounded-xl bg-slate-50 p-3">
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Issue</p>
                <p className="mt-1 text-sm font-medium leading-6 text-slate-800">{c.issue || "-"}</p>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}

export default CurrentComplaints;

